class ProductItemForm extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('submit', e => {
      e.preventDefault()
      const form = new FormData(e.target)
      const data = Object.fromEntries(form)
      const config = JSON.parse(this.querySelector(`[data-quick-buy-settings]`).textContent)
      console.log(data,config)
      if(!data.id) return
      // Sending
      const formData = [{
        name: 'id',
        value: data.id
      }, {
        name: 'quantity',
        value: data.quantity
      }];
      const options = {
        atcButton: this.querySelector('.product-form--atc-button'),
        settings: {
          moneyFormat: config.money_format,
          cartRedirection: config.cart_redirection
        }
      };
      const res = new AddToCartFlyout(formData, options);
    })

    // Interactive
    const select = this.querySelector('.options-selection__input-select')
    const prices = [...this.querySelectorAll('.product-items-prices__item')]
  
    if(select) select.addEventListener('change', () => {
      select.querySelectorAll('option').forEach((option,index) => {
        let action
        if(option.selected) action = 'add'
        else action = 'remove'
        prices[index].classList[action]('active')
      })
    })
  }
}
window.customElements.define('productitem-form', ProductItemForm)